import doubleChargeRefundVenuesCsv from './doubleChargeRefundVenues.csv?raw';

/**
 * Parse restIds from the double-charge venues CSV (first column).
 * restId is always unquoted and comma-free, so a simple split is safe.
 */
const parseRestIdsFromCsv = (csvText) => {
  const ids = new Set();

  for (const line of csvText.split(/\r?\n/)) {
    if (!line || line.startsWith('restId')) {
      continue;
    }

    const restId = line.split(',')[0]?.trim();
    if (restId) {
      ids.add(restId);
    }
  }

  return ids;
};

export const DOUBLE_CHARGE_REFUND_REST_IDS = parseRestIdsFromCsv(doubleChargeRefundVenuesCsv);
